/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'FAQs - CamAPS FX',
    titleMeta: 'Have a question about CamAPS FX?',
    descriptionMeta: 'Here are the answers to some of your frequently asked questions about compatible devices, ' +
        'regulatory approval, availability, and clinical research',
    keywords:
        'camaps faqs, camaps fx faqs, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'en_gb',

    haveQuestion: 'Have a question about CamAPS FX?',
    hereAnswers: 'Here are the answers to some of your frequently asked questions.',
    whatIsCamAPS: 'What is CamAPS FX?',
    whatIsCamAPSAnswer: 'CamAPS FX is a sophisticated, easy-to-use mobile app to manage glucose levels in people ' +
        'with type 1 diabetes, aged one year and older, using an advanced adaptive hybrid closed-loop approach.',
    isApproved: 'Is CamAPS FX approved for use?',
    isApprovedAnswer: 'The app has been extensively tested in clinical trials and is approved for use in a number of countries and regions, including Australia, Canada, the European Union, New Zealand, Norway, Switzerland, the United Kingdom, and the United States.',
    isAvailable: 'Is CamAPS FX available in my area?',
    isAvailableAnswer1: 'CamAPS FX is available in selected diabetes clinics. Please check with your clinic.',
    isAvailableAnswer2: '',
    isAvailableAnswer3: '',
    whatIsLiberty: 'What is CamAPS Liberty?',
    whatIsLibertyAnswer: 'CamAPS Liberty is a feature within CamAPS FX. When activated, users are not required to count carbohydrates or bolus for meals and snacks.',
    whatIsLibertyMoreInfo1: 'For more information visit our ',
    whatIsLibertyPageLink: 'CamAPS Liberty page',
    whatIsLibertyMoreInfo2: ' or download this ',
    whatIsLibertyFactsheetLink: 'factsheet',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_en.pdf',
    cost: 'How much does CamAPS FX cost?',
    costAnswer1: 'For costing details, please visit the',
    costAnswer2: 'section of the website.',
    compatibleCgm: 'What CGMs are compatible with CamAPS FX?',
    compatibleCgmBody: 'CamAPS FX is compatible with Dexcom G6, Dexcom G7, FreeStyle Libre 3 and FreeStyle Libre 3 Plus. Please click the links to view compatible smartphones and operating systems.',
    whatPumps: 'What insulin pumps are compatible with CamAPS FX?',
    whatPumpsAnswer1: 'CamAPS FX is compatible with YpsoPump insulin pumps on Google Play and the Apple App Store.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: 'CamAPS FX is compatible with Dana insulin pumps on Google Play (UK only).',
    whatPumpsAnswerHtml: 'https://advancedtherapeutics.org.uk/shop/dana-diabecare-insulin-pump/dana-i-insulin-pump',
    whatPhone: 'What smartphones are compatible with CamAPS FX?',
    whatPhoneAnswer: 'Your smartphone must be compatible with the CGM you use.',
    cgmManufacturerListText: 'Please check your CGM manufacturer\'s compatibility list for Dexcom G6, Dexcom G7, FreeStyle Libre 3 or FreeStyle Libre 3 Plus.',
    whatOperating: 'What operating systems are compatible with CamAPS FX?',
    whatOperatingAnswer: 'CamAPS FX supports Android 13 to 16 and iOS 18 to 27, including subsequent minor releases. Your operating system must also be compatible with the CGM you use.',
    whatOperatingManufacturerText: 'Please check your CGM manufacturer\'s compatibility list for Dexcom G6, Dexcom G7, FreeStyle Libre 3 or FreeStyle Libre 3 Plus.',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerDexcomG7Html:'https://www.dexcom.com/en-GB/compatibility/g7',
    whatPhoneAnswerLibreHtml:'https://freestyleserver.com/Payloads/IFU/2026/q2/ART43193-006_rev-AP-pub.pdf',

    whereUpload: 'Where can I upload my data to from CamAPS FX? ',
    whereUploadAnswer: 'At present, data from CamAPS FX can be uploaded to mylife Cloud and Glooko.',
    whatLanguage: 'What languages are available within CamAPS FX?',
    whatLanguageAnswer: 'CamAPS FX is available in English, Czech, Danish, Dutch, French, Finnish, German, Italian, Norwegian, Polish, Spanish, and Swedish.',
    whereResults: 'Where can I find the results of your clinical trials?',
    whereResultsAnswer1: 'Publications related to the use of Cambridge control algorithm are available to download',
    whereResultsAnswer2: 'here.',
    whereResultsAnswer3: 'Key publications were published in',
    whereResultsAnswer4: 'and',

    wantMoreInfoIOS: 'Want to know more about the CamAPS FX iOS app?',
    wantMoreInfoIOSanswer1: 'Please&nbsp;',
    wantMoreInfoIOSanswer2: 'click here',
    wantMoreInfoIOSanswer3: 'to read more.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_EN_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_EN.pdf',

    danaOnGooglePlayHeading: 'How do Dana users download the CamAPS FX from Google Play?',
    danaOnGooglePlayAnswer1: 'Please',
    danaOnGooglePlayAnswer2: 'click here',
    danaOnGooglePlayAnswer3: 'to read more.',
    danaOnGooglePlayAnswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/downloading_dana_camaps_fx.pdf',

};
